import React from 'react';
import Alert, { AlertColor } from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { AlertTitle } from '@mui/material';
import { useTailwindBrand } from './shared';

interface alertModel {
  info: AlertColor,
  msg: string | any,
  customClass?: string,
  title?: string
}

const AlertInfo = (props: alertModel) => {
  const { classes, brandConfig } = useTailwindBrand();
  return (
    <Stack sx={{ width: "100%" }} spacing={2}>
      <Alert variant="outlined" severity={props.info} sx={{ fontFamily: brandConfig.fontFamily }} className={props.customClass} >
        <AlertTitle className={`font-bold lg:text-lg md:text-base ${classes.fontFamily}`} >{props.title}</AlertTitle>
        {props.msg}
      </Alert>
    </Stack>
  );
};

export default AlertInfo;